import {FaqItem} from './faqItem';
import './faq.css';
export const FAQ = ( props ) => {
    return (
        <div id="faq">
            <div className='container'>
                <div className='section-title'>
                    <h2>FAQs</h2>
                    <div className="faq-container">
                        <FaqItem title="1. What is RubyRock?" content={
                            <>
                            <p>RUBYROCK is: </p>
                            <ul>
                                <li>1. an NFT backed by a Ruby Specimen through the issuance of our native token RBY.</li>
                                <li>2. a DeFi instrument for future passive income and various rewards.</li>
                                <li>3. a collection of multiple artistic layers (83) of different designs and colors representing the ruby stone Specimen and its source, Tanzania.</li>
                            </ul>
                            </>
                        } boxSize="110px"/>
                        <FaqItem title="2. What is the RBY Token?" content={
                            <>
                            <p>RBY is an ERC-20 token backed by the economic rights of the Ruby Specimen with a total supply of 327,000,000 tokens, which represents 32,700 Carats – thus 100% backed by the total weight of the Ruby Specimen.</p>
                            <p><strong>10,000 RBY = 1 Carat</strong></p>
                            <p>Each RUBYROCK is pegged to a certain amount of RBY equals to the minting price, giving to the RUBYROCK a solid intrinsic value.</p>
                            </>
                        } boxSize="110px"/>
                        <FaqItem title="3. What is the Ruby Specimen?" content={
                            <>
                            <p>Our rough Ruby stone is a million-year-old stone that was mined in Arusha region, in the village of Longido, Tanzania, West Africa; it weighs 6,540 grams, with a total of 32,700 carats, and is confirmed to be a Natural Corundum Ruby in Zoisite Matrix by GIA (Gemological Institute of America), the most recognized gemstones’ analysis laboratory in the world.</p>
                            <p>The Ruby Specimen is appraised at USD 261,600,000 millions, and is safely stored in a vault at “Ferrari Group Safety House” in Geneva Free Ports, Switzerland.</p>
                            </>
                        } boxSize="90px"/>
                        <FaqItem title="4. How are Rubies formed?" content={
                            <>
                            <p>Rubies are formed by the complex process of crystallization (10-30 million years). These red gemstones are second only to diamond in hardness. As a result, rubies form when chromium oxide enters the mineral conundrum (Aluminum oxide).</p>
                            </>
                        } boxSize="60px"/>
                        <FaqItem title="5. What does it mean the economic rights are backing the RBY tokens?" content={
                            <>
                            <p>SpecimenLabs is the owner of the Ruby Specimen and holds the “Safety Keeping Receipt” (SKR) issued by Ferrari Group Safety House, where the Ruby Specimen and all its documents are stored. </p>
                            <p>By a legal agreement (drafted by BROSETA Law Firm, Spain), Specimen Labs has committed to forward to the community wallet (i.e the Vault) all proceeds issued from any use of the SKR, including the eventual partial or total sale of the SKR (i.e., sale of the Ruby Specimen).</p>
                            <p>All proceeds will be dropped into the community wallet and distributed to each RubyRock NFT holder in accordance to amount of RBY Tokens they are pegged to.</p>
                            </>
                        } boxSize="120px"/>
                        <FaqItem title="6. What makes this NFT project different from others?" content={
                            <>
                            <p>RUBYROCK combines the value and quality of a traditional asset, with the innovative advantages of blockchain technology by linking the NFT to the economic rights of the Ruby Specimen via our native RBY Token.</p>
                            </>
                        } boxSize="60px"/>
                        <FaqItem title="7. How many RubyRocks will be issued and how can I get one?" content={
                            <>
                            <p>20,000 RubyRock NFTs are issued and sold as follows:</p>
                            <ol>
                                <li>5,000 RUBYROCKs proposed in a pre-sale for whitelisted individuals or entities.</li>
                                <li>14,000 RUBYROCKs are to be sold in a public sale, scheduled to take place a few days after the whitelisted pre-sale.</li>
                                <li>1,000 RUBYROCKs will be allocated for the team and marketing.</li>
                            </ol>
                            </>
                        } boxSize="110px"/>
                        <FaqItem title="8. How can I register for the Whitelist?" content={
                            <>
                            <ul>
                                <li>1. Register with your mail on our website</li>
                                <li>2. You will receive an email to confirm your registration</li>
                                <li>3. receive an invitation with a link to connect your Metamask wallet at a precise date</li>
                            </ul>
                            </>
                        } boxSize="90px"/>
                        <FaqItem title="9. What is the mint price of RubyRock?" content={
                            <>
                            <p>At launch date, Each RUBYROCK is minted at $1,000 + gas fees directly from our website or from the OPENSEA platform. We accept payment in ETH, USDT, or APECOIN.</p>
                            </>
                        } boxSize="50px"/>
                        <FaqItem title="10. Will it be a delayed reveal or instant reveal?" content={
                            <>
                            <p>Once your RubyRock is minted, you will be able to view your NFT after its reveal in your MetaMask mobile Wallet or on OpenSea.</p>
                            </>
                        } boxSize="50px"/>
                        <FaqItem title="11. How RubyRock will generate passive income?" content={
                            <>
                            <p>Two ways in Phase 1:</p>
                            <ul>
                                <li>1. <strong>Rewards Pool:</strong> 50% of every ETH transaction is destined to a pool to be distributed quarterly (unclaimed rewards will remain in the pool for the next rewards airdrop)</li>
                                <li>2. <strong>Staking options:</strong> Staking will be available through the various phases of the project</li>
                            </ul>
                            </>
                        } boxSize="90px"/>
                        <FaqItem title="12. Where are the NFTs images and the Metadata hosted?" content={
                            <>
                            <p>The NFT images and Metadata are hosted by IPFS, which means they will never disappear.</p>
                            </>
                        } boxSize="50px"/>
                        <FaqItem title="13. Will the contract be fully audited and the community will be able to verify the contract?" content={
                            <>
                            <p>Yes, the contract will undergo multiple published audits and will be released to the community to verify the pre-mint.</p>
                            </>
                        } boxSize="50px"/>
                        <FaqItem title="14. What's next?" content={
                            <>
                            <p>Our team is already working on a second phase with much more to come, such as: airdrops and sales of a new art collection, pools in DeFi with RBY Tokens, creation of RubyBuddy collection as pfp, and more...</p>
                            </>
                        } boxSize="50px"/>

                    </div>
                </div>
            </div>
        </div>
    )
  }